import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  totalAdmission=0;
  totalDues=0;
  balance=0;
  student=0;
  donar=0;
  pendingBalance=0;
  donationBalance=0
  constructor(private route:ActivatedRoute) { }

  ngOnInit() {
    this.route.data.subscribe(data=>{
      /*this.totalAdmission=data.dash[0].totalAdmission;
      this.totalDues=data.dash[1].total;*/
      this.balance=(data.dash[0].data.amount)?parseInt(data.dash[0].data.amount):0;
      this.student=(data.dash[2].total)?parseInt(data.dash[2].total):0;
      this.donar=(data.dash[1].total)?parseInt(data.dash[1].total):0;
      this.pendingBalance=data.dash[3].totalPendingAmount;
      this.donationBalance=data.dash[4].totalDonation;

    },(error)=>{});
  }

}
